export enum ChannelName {
  SOCIETY_ALERT = "Alert:Society:",
}

export enum ChannelEventType {
  NOTIFICATION = "notification",
  NEW_MESSAGE = "NewMessage",
}
